export const navigation = [{
  path: '/'
},
{
  path: '/dashboard'
},
{
  path: '/question'
},
{
  path: '/user'
}
]
